import { render, staticRenderFns } from "./CopyStakeGamificationCenterWheelOfFortuneTab.vue?vue&type=template&id=75f1c50b&scoped=true&lang=pug"
import script from "./CopyStakeGamificationCenterWheelOfFortuneTab.vue?vue&type=script&lang=ts"
export * from "./CopyStakeGamificationCenterWheelOfFortuneTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f1c50b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow,VSwitch})
